export default {
  steps: {
    policyholderDetails: 'بيانات مالك الوثيقة',
    policyAndProfessionInfo: 'الوثيقة و التخصص الطبي',
    declarationsDetails: 'تصريحات مالك الوثيقة',
    quoteList: 'قائمة الأسعار',
    summaryAndPayment: 'التفاصيل والدفع',
  },
} as const
